var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_145",
    "data-name": "Group 145",
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.705,
    height: 196.779,
    viewBox: "0 0 197.705 196.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M42.136,37.88a2.963,2.963,0,0,1-2.963-2.963V18.807a1.857,1.857,0,0,0-1.852-1.852H31.273a2.963,2.963,0,0,1-2.963-2.963,3,3,0,0,1,2.963-2.963h6.049A7.784,7.784,0,0,1,45.1,18.807v16.11a2.963,2.963,0,0,1-2.963,2.963h0Z",
    transform: "translate(146.433 57.053)",
    fill: "#5392f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M37.282,67.925c-11.543,0-21.3-5.432-28.332-15.8A54.8,54.8,0,0,1,0,22.5C0,16.632,1.111,11.508,3.148,7.8,5.617,3.3,9.506.83,14.012.83h5.74a2.963,2.963,0,0,1,2.963,2.963,3,3,0,0,1-2.963,2.963h-5.74c-2.407,0-4.259,1.3-5.679,3.889C6.79,13.484,5.926,17.681,5.926,22.5A48.273,48.273,0,0,0,13.888,48.79C17.962,54.778,25.369,62,37.282,62S56.6,54.839,60.676,48.79A48.43,48.43,0,0,0,68.638,22.5c0-11.666-4.382-15.74-8.086-15.74h-5.74a2.963,2.963,0,0,1-2.963-2.963A3,3,0,0,1,54.812.83h5.74c8.518,0,14.012,8.518,14.012,21.727a54.636,54.636,0,0,1-8.95,29.628c-7.037,10.308-16.789,15.8-28.332,15.8h0Z",
    transform: "translate(0 4.293)",
    fill: "#94d8e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M10.646,16.11H3.918A1.37,1.37,0,0,1,2.56,14.752V1.358A1.37,1.37,0,0,1,3.918,0h6.728a4.294,4.294,0,0,1,4.321,4.321v7.407a4.294,4.294,0,0,1-4.321,4.321Z",
    transform: "translate(13.242)",
    fill: "#fbb540"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M11.821,16.11h6.728a1.37,1.37,0,0,0,1.358-1.358V1.358A1.37,1.37,0,0,0,18.549,0H11.821A4.294,4.294,0,0,0,7.5,4.321v7.407a4.294,4.294,0,0,0,4.321,4.321Z",
    transform: "translate(38.794)",
    fill: "#fbb540"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M7.98,13.139v87.649l36.973,3.889,36.973-3.889V13.139L46.188,9.25,7.98,13.139Z",
    transform: "translate(41.276 47.846)",
    fill: "#94d8e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M21.4,13.966v99.439a3.517,3.517,0,0,1-3.518,3.518H27.2a3.517,3.517,0,0,0,3.518-3.518V13.966L25.6,9.09Z",
    transform: "translate(92.484 47.018)",
    fill: "#5d939e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M78.408,7.4H11.5A3.517,3.517,0,0,0,7.98,10.918V22.708H81.926V10.918A3.517,3.517,0,0,0,78.408,7.4Z",
    transform: "translate(41.276 38.276)",
    fill: "#5d939e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M78.408,39.388H11.5A3.517,3.517,0,0,1,7.98,35.869V24.08H81.926V35.869a3.517,3.517,0,0,1-3.518,3.518Z",
    transform: "translate(41.276 124.554)",
    fill: "#5d939e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M30.719,35.869V24.08H21.4V35.869a3.517,3.517,0,0,1-3.518,3.518H27.2A3.517,3.517,0,0,0,30.719,35.869Z",
    transform: "translate(92.484 124.554)",
    fill: "#4071f7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M30.719,22.708V10.918A3.517,3.517,0,0,0,27.2,7.4H17.88A3.517,3.517,0,0,1,21.4,10.918V22.708Z",
    transform: "translate(92.484 38.276)",
    fill: "#365f7e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M120.253,91.157H16.617A2.055,2.055,0,0,1,14.58,89.12V22.457a2.055,2.055,0,0,1,2.037-2.037H120.253a2.055,2.055,0,0,1,2.037,2.037V89.12A2.055,2.055,0,0,1,120.253,91.157Z",
    transform: "translate(75.415 105.622)",
    fill: "#b9f6d3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M39.3,20.42H30.23a2.055,2.055,0,0,1,2.037,2.037V89.12a2.055,2.055,0,0,1-2.037,2.037H39.3A2.055,2.055,0,0,0,41.34,89.12V22.457A2.055,2.055,0,0,0,39.3,20.42Z",
    transform: "translate(156.364 105.622)",
    fill: "#94d8e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M32.968,8.17a7.1,7.1,0,0,0-7.1,7.1v7.1H40v-7.1a7.1,7.1,0,0,0-7.1-7.1Z",
    transform: "translate(133.812 42.259)",
    fill: "#fbb540"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M25.752,24.149c1.6,8.395,3.889,15.8,6.728,20.246a1.672,1.672,0,0,0,2.778,0c2.9-4.444,5.185-11.851,6.728-20.246L33.838,20.26,25.69,24.149Z",
    transform: "translate(132.881 104.795)",
    fill: "#fbb540"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M30.44,24.407A92.508,92.508,0,0,1,26.49,41.2a35.1,35.1,0,0,0,1.852,3.457,1.672,1.672,0,0,0,2.778,0c2.9-4.444,5.185-11.851,6.728-20.246l-3.518-4.2-3.95,4.2Z",
    transform: "translate(137.019 104.536)",
    fill: "#ff8b5a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M25.25,11.756V45.211A163.116,163.116,0,0,0,28.028,74.9h16.3A168.249,168.249,0,0,0,47.1,45.211V11.756a1.266,1.266,0,0,0-1.3-1.3H26.546a1.266,1.266,0,0,0-1.3,1.3h0Z",
    transform: "translate(130.605 54.104)",
    fill: "#407194"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M27.13,74.891H34.6A168.25,168.25,0,0,0,37.376,45.2V11.746a1.266,1.266,0,0,0-1.3-1.3H28.365a1.193,1.193,0,0,1,1.049,1.3V45.2a211.7,211.7,0,0,1-2.222,29.69h0Z",
    transform: "translate(140.33 54.053)",
    fill: "#365f7e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M72.341,39.878H63.267a7.877,7.877,0,0,0-7.9,7.9V71.42a1.989,1.989,0,0,1-1.975,1.975H12.653a5.926,5.926,0,1,1,0-11.851h11.11a11.851,11.851,0,0,0,0-23.7H12.036a5.37,5.37,0,0,1,0-10.74h18.7a5.532,5.532,0,0,0,5.555-5.555V11.67c-.988.062-1.975.123-2.963.123a23.787,23.787,0,0,1-2.963-.123v9.506H12.036a11.3,11.3,0,0,0,0,22.591H23.763a5.926,5.926,0,1,1,0,11.851H12.653a11.851,11.851,0,0,0,0,23.7H53.391a7.877,7.877,0,0,0,7.9-7.9V47.779A1.95,1.95,0,0,1,63.267,45.8h9.074A2.963,2.963,0,0,0,75.3,42.841a3,3,0,0,0-2.963-2.963h0Z",
    transform: "translate(3.828 60.363)",
    fill: "#5d939e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M36.361,28.376H20.313a2.963,2.963,0,0,1-2.963-2.963,3,3,0,0,1,2.963-2.963H36.361a2.963,2.963,0,0,1,2.963,2.963A3,3,0,0,1,36.361,28.376Z",
    transform: "translate(89.743 116.123)",
    fill: "#5392f9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M87.84,31.6H20.313a2.963,2.963,0,0,1-2.963-2.963,3,3,0,0,1,2.963-2.963H87.84A2.963,2.963,0,0,1,90.8,28.633,3,3,0,0,1,87.84,31.6Z",
    transform: "translate(89.743 132.778)",
    fill: "#5d939e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M87.84,34.826H20.313a2.963,2.963,0,0,1-2.963-2.963A3,3,0,0,1,20.313,28.9H87.84A2.963,2.963,0,0,1,90.8,31.863a3,3,0,0,1-2.963,2.963Z",
    transform: "translate(89.743 149.485)",
    fill: "#5d939e"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 12.036,
    cy: 12.036,
    rx: 12.036,
    ry: 12.036,
    transform: "translate(74.132 91.168)",
    fill: "#ddebfd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.1246c7740a2a65a6f82be4798975d5b6.svg";
export { ForwardRef as ReactComponent };